import _classCallCheck from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/mvarble/dropbox/Dropbox/development/websites/matthew-varble-site/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { InstancedBufferGeometry, Box3, Vector3, Float32BufferAttribute, InstancedInterleavedBuffer, InterleavedBufferAttribute, WireframeGeometry, Sphere } from 'three';

var LineSegmentsGeometry = /*#__PURE__*/function (_InstancedBufferGeome) {
  _inherits(LineSegmentsGeometry, _InstancedBufferGeome);

  var _super = _createSuper(LineSegmentsGeometry);

  function LineSegmentsGeometry() {
    var _this;

    _classCallCheck(this, LineSegmentsGeometry);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "isLineSegmentsGeometry", true);

    _defineProperty(_assertThisInitialized(_this), "type", 'LineSegmentsGeometry');

    _defineProperty(_assertThisInitialized(_this), "boundingBox", null);

    _defineProperty(_assertThisInitialized(_this), "boundingSphere", null);

    _defineProperty(_assertThisInitialized(_this), "box", new Box3());

    _defineProperty(_assertThisInitialized(_this), "vector", new Vector3());

    var positions = [-1, 2, 0, 1, 2, 0, -1, 1, 0, 1, 1, 0, -1, 0, 0, 1, 0, 0, -1, -1, 0, 1, -1, 0];
    var uvs = [-1, 2, 1, 2, -1, 1, 1, 1, -1, -1, 1, -1, -1, -2, 1, -2];
    var index = [0, 2, 1, 2, 3, 1, 2, 4, 3, 4, 5, 3, 4, 6, 5, 6, 7, 5];

    _this.setIndex(index);

    _this.setAttribute('position', new Float32BufferAttribute(positions, 3));

    _this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));

    return _this;
  }

  _createClass(LineSegmentsGeometry, [{
    key: "applyMatrix4",
    value: function applyMatrix4(matrix) {
      var start = this.attributes.instanceStart;
      var end = this.attributes.instanceEnd;

      if (start !== undefined) {
        start.applyMatrix4(matrix);
        end.applyMatrix4(matrix);
        start.needsUpdate = true;
      }

      if (this.boundingBox !== null) {
        this.computeBoundingBox();
      }

      if (this.boundingSphere !== null) {
        this.computeBoundingSphere();
      }

      return this;
    }
  }, {
    key: "setPositions",
    value: function setPositions(array) {
      var lineSegments;

      if (array instanceof Float32Array) {
        lineSegments = array;
      } else if (Array.isArray(array)) {
        lineSegments = new Float32Array(array);
      } else {
        console.error('LineSegmentsGeometry.setPosition requires either a Float32Array or regular array of numbers');
        return this;
      }

      var instanceBuffer = new InstancedInterleavedBuffer(lineSegments, 6, 1); // xyz, xyz

      this.setAttribute('instanceStart', new InterleavedBufferAttribute(instanceBuffer, 3, 0)); // xyz

      this.setAttribute('instanceEnd', new InterleavedBufferAttribute(instanceBuffer, 3, 3)); // xyz
      //

      this.computeBoundingBox();
      this.computeBoundingSphere();
      return this;
    }
  }, {
    key: "setColors",
    value: function setColors(array) {
      var colors;

      if (array instanceof Float32Array) {
        colors = array;
      } else if (Array.isArray(array)) {
        colors = new Float32Array(array);
      } else {
        console.error('LineSegmentsGeometry.setColors requires either a Float32Array or regular array of numbers');
        return this;
      }

      var instanceColorBuffer = new InstancedInterleavedBuffer(colors, 6, 1); // rgb, rgb

      this.setAttribute('instanceColorStart', new InterleavedBufferAttribute(instanceColorBuffer, 3, 0)); // rgb

      this.setAttribute('instanceColorEnd', new InterleavedBufferAttribute(instanceColorBuffer, 3, 3)); // rgb

      return this;
    }
  }, {
    key: "fromWireframeGeometry",
    value: function fromWireframeGeometry(geometry) {
      this.setPositions(Array.from(geometry.attributes.position.array));
      return this;
    }
  }, {
    key: "fromEdgesGeometry",
    value: function fromEdgesGeometry(geometry) {
      this.setPositions(Array.from(geometry.attributes.position.array));
      return this;
    }
  }, {
    key: "fromMesh",
    value: function fromMesh(mesh) {
      this.fromWireframeGeometry(new WireframeGeometry(mesh.geometry));
      return this;
    }
  }, {
    key: "fromLineSegments",
    value: function fromLineSegments(lineSegments) {
      var geometry = lineSegments.geometry;

      if (geometry.isBufferGeometry) {
        this.setPositions(Array.from(geometry.attributes.position.array)); // assumes non-indexed
      } // set colors, maybe


      return this;
    }
  }, {
    key: "computeBoundingBox",
    value: function computeBoundingBox() {
      if (this.boundingBox === null) {
        this.boundingBox = new Box3();
      }

      var start = this.attributes.instanceStart;
      var end = this.attributes.instanceEnd;

      if (start !== undefined && end !== undefined) {
        this.boundingBox.setFromBufferAttribute(start);
        this.box.setFromBufferAttribute(end);
        this.boundingBox.union(this.box);
      }
    }
  }, {
    key: "computeBoundingSphere",
    value: function computeBoundingSphere() {
      if (this.boundingSphere === null) {
        this.boundingSphere = new Sphere();
      }

      if (this.boundingBox === null) {
        this.computeBoundingBox();
      }

      var start = this.attributes.instanceStart;
      var end = this.attributes.instanceEnd;

      if (start !== undefined && end !== undefined) {
        var center = this.boundingSphere.center;

        if (this.boundingBox) {
          this.boundingBox.getCenter(center);
        }

        var maxRadiusSq = 0;

        for (var i = 0, il = start.count; i < il; i++) {
          this.vector.fromBufferAttribute(start, i);
          maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(this.vector));
          this.vector.fromBufferAttribute(end, i);
          maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(this.vector));
        }

        this.boundingSphere.radius = Math.sqrt(maxRadiusSq);

        if (isNaN(this.boundingSphere.radius)) {
          console.error('THREE.LineSegmentsGeometry.computeBoundingSphere(): Computed radius is NaN. The instanced position data is likely to have NaN values.', this);
        }
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {// todo
    }
  }]);

  return LineSegmentsGeometry;
}(InstancedBufferGeometry);

export { LineSegmentsGeometry };